module.exports = __webpack_public_path__ + "img/wlzg-app.3bad08fd.png";